module.exports = __webpack_public_path__ + "img/7.89217f72.jpg";